module.exports = __webpack_public_path__ + "img/portfolio1m-m@1.20b5e1cf.jpg";